/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CdpTrackEventRequest} from '@cash-web/protos/squareup/cash/cashdotapp/app.pb'
import {CdpTrackEventResponse} from '@cash-web/protos/squareup/cash/cashdotapp/app.pb'


export const cdpTrackEventCashDotApp = (request: CdpTrackEventRequest, options?: CashRequestOptions) => post<CdpTrackEventRequest, CdpTrackEventResponse>("/2.0/cash/cdp-track-event-cash-dot-app", request, {...options, rejectOnError: true })